function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var PreguntaBusquedaComponentCtrl = /*#__PURE__*/function () {
  PreguntaBusquedaComponentCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos"];
  function PreguntaBusquedaComponentCtrl($element, $log, $timeout, AccesoDatos) {
    _classCallCheck(this, PreguntaBusquedaComponentCtrl);
    this.$element = $element;
    this.$log = $log;
    this.$timeout = $timeout;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PreguntaBusquedaComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this$datosTipos;
      this.$log.info('[PreguntaBusquedaComponentCtrl] onInit');
      this.statesList = ((_this$datosTipos = this.datosTipos) === null || _this$datosTipos === void 0 ? void 0 : _this$datosTipos.estadosStore().list) || [];
      this.titleFilter = this.titlepreg || 'Filter';
      if (this.condicion.pregform) {
        this.seleccionaPreg();
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      this.$timeout(function () {
        // (this.$element.find('select') as any).formSelect();
        // (this.$element.find('.datepicker') as any).datepicker({ autoClose: true, showClearBtn: true, firstDay: 1 });
      }, 200);
    }
  }, {
    key: "cambioPreg",
    value: function cambioPreg() {
      this.seleccionaPreg();
      this.onChangeCond();
    }
  }, {
    key: "seleccionaPreg",
    value: function seleccionaPreg() {
      var _this = this;
      // obtener las preguntas del formulario
      this.AccesoDatos.GestionCurr_CLIENT.valoresParaSeleccion(this.busqueda.idform, this.condicion.pregform.qf.idformq, this.condicion.pregform.q.idquest).then(function (valoresResponse) {
        _this.$log.info('Valores posibles', valoresResponse);
        _this.valores = valoresResponse;
        _this.$postLink();
      });
    }
  }]);
}();
angular.module('candidato').component('preguntaBusqueda', {
  bindings: {
    busqueda: '<',
    titlepreg: '@',
    condicion: '<',
    datosTipos: '<',
    onChangeCond: '&',
    onDeleteCond: '&'
  },
  controller: PreguntaBusquedaComponentCtrl,
  // templateUrl: "pregunta-busqueda.component.html",
  template: require('./pregunta-busqueda.component.html')
});